import { createApi } from '@reduxjs/toolkit/query/react';
import { METRICS_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { MetricResponse } from 'services/types';

export const metricsApi = createApi({
  reducerPath: METRICS_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getMetrics: builder.query<MetricResponse[], void>({
      query: () => encodeURI(`/metrics`),
    }),
  }),
});

export const { useGetMetricsQuery } = metricsApi;
